import { Component, Input, OnInit } from '@angular/core';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
declare var $;
@Component({
  selector: 'app-sw-relation-box',
  templateUrl: './sw-relation-box.component.html',
  styleUrls: ['./sw-relation-box.component.css']
})
export class SwRelationBoxComponent implements OnInit {

  // 快捷操作：新增关系、编辑关系
  @Input() state:string
  comentParams:any = {
    upOrAdd: 'Add',           // 新增/编辑实体
    relationData: {}          // 编辑关系时需传递的参数
  }

  constructor(
    private jwt: SwJwtService
  ) { }

  ngOnInit() {
  }

  ngOnChanges(){
    console.log('relationPage',this.state);
    if(this.state == 'addRelation'){
      $('.relationBox').css('right','0');
    }else if(this.state == 'editRelation'){
      $('.relationBox').css('right','0');
      this.comentParams = JSON.parse(this.jwt.getToken('relationInfo'));
    }else{
      $('.relationBox').css('right','-660px');
    }
  }

  // 执行保存、最小化、关闭操作，需关闭右侧弹出框
  componentStateChange(event){
    $('.relationBox').css('right','-660px');
  }
}
